import { AbstractControl, ValidatorFn } from '@angular/forms';

export function validCustomValidators(validators: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!validators) {
      return null;
    }

    const validatorsJSON = JSON.parse(validators);
    let returnValidator = {};
    const value = control.value;

    MaxLength(value, validatorsJSON.max_length, returnValidator)
    MinLength(value, validatorsJSON.min_length, returnValidator)

    return returnValidator;
  };
}

function MaxLength(value, maxLength, returnValidator) {
  if (!isNullOrUndefinedOrEmpty(maxLength) && maxLength.flag_max_length) {
    if (Array.isArray(value) && value.length > maxLength.value) {
      returnValidator.maxLength = true;
      returnValidator.maxValue = maxLength.value
    }
  }
}

function MinLength(value, minLength, returnValidator) {
  if (!isNullOrUndefinedOrEmpty(minLength) && minLength.flag_min_length) {
    if (Array.isArray(value) && value.length < minLength.value) {
      returnValidator.minLength = true;
      returnValidator.minValue = minLength.value
    }
  }
}

function isNullOrUndefinedOrEmpty(value) {
  return value === null || value === undefined || value === '';
}